/* eslint no-unused-vars: "off" */
import { NumberFormat } from "intl";
import "intl/locale-data/jsonp/fi.js";

const formatter = new NumberFormat("fi", {minimumFractionDigits: 0, maximumFractionDigits: 1});

export const formatVolume = (value) => {
  return formatter.format(value) + " m³";
};
